import React from 'react';
import cx from 'classnames';

import Text from '../Text';
import Touchable, { TouchableProps } from '../Touchable';

import styles from './InlineLink.module.scss';

export type Props = TouchableProps & {
  /** Apply CSS class `InlineLink` text.*/
  textClassName?: Parameters<typeof cx>[0];
};

export const InlineLink: React.FC<Props> = ({
  children,
  className,
  textClassName,
  ...restProps
}) => (
  <Touchable {...restProps} className={cx(styles.inlinelink, className)}>
    <Text as='span' className={cx(styles.text, textClassName)}>
      {children}
    </Text>
  </Touchable>
);

InlineLink.displayName = 'InlineLink';
export default InlineLink;
export { styles };
